import React from 'react';

const Channels = () => {
    return (
        <div>
            <h2>信道</h2>
        </div>
    );
};

export default Channels;